// User configuration with roles and avatars
// Roles: "developer" - full access, can see admin features
//        "user" - standard user access

export const USERS = [
  {
    email: "chris@satori-ai.com",
    name: "Chris Daly",
    role: "developer",
    avatar: "https://ca.slack-edge.com/T05A5R2RSD6-U059D6DLDJ9-25c0116d4c68-512",
  },
  {
    email: "eden@satori-ai.com",
    name: "Eden Goonesekera",
    role: "developer",
    avatar: "https://ca.slack-edge.com/T05A5R2RSD6-U059JK4HUVA-707968a81ad9-512",
  },
  {
    email: "lucas.catalan.galan@gmail.com",
    name: "Lucas Galan",
    role: "user",
    avatar: "https://ca.slack-edge.com/T05A5R2RSD6-U0599G2HB62-2dd1c3f2abc0-512",
  },
  {
    email: "m-a-r-k@m-o-n-i-k-a.com",
    name: "Mark Liney",
    role: "user",
    avatar: "https://ca.slack-edge.com/T05A5R2RSD6-U0599FVSH2A-bcc951407291-192",
  },
  {
    email: "j-a-c-k@m-o-n-i-k-a.com",
    name: "Jack Wimmer",
    role: "user",
    avatar: null,
  },
  {
    email: "jsfothergill@gmail.com",
    name: "James Fothergill",
    role: "user",
    avatar: null,
  },
];

// Helper to get allowed emails list
export const getAllowedEmails = () => USERS.map(u => u.email);

// Helper to get user config by email
export const getUserByEmail = email => USERS.find(u => u.email === email);

// Helper to check if user is developer
export const isDeveloper = email => {
  const user = getUserByEmail(email);
  return user?.role === "developer";
};

// Helper to get avatar URL for a user
export const getAvatarUrl = (email, fallbackPhotoURL = null) => {
  const user = getUserByEmail(email);
  return user?.avatar || fallbackPhotoURL || null;
};
